import styled from 'styled-components/native';

// TouchableOpacity do próprio React Native, e NÃO o `RectButton` do
// react-native-gesture-handler que estava aqui antes — mesmo motivo já
// registrado no TouchableText:
//
// O RNGH v2 exige um `GestureHandlerRootView` envolvendo o app, e esse wrapper
// não existe neste projeto. Dentro de um `Modal` do react-native-web o botão
// nunca recebia o toque e o `onPress` não disparava — sem erro nenhum no
// console. Era o caso do "Novo canal" da comunidade, do "Salvar" do formulário
// de canal e dos botões dos modais de produto (estes já haviam sido trocados
// por Pressable, um a um).
export const Container = styled.TouchableOpacity`
  width: ${({ width }) => width};
  padding: ${({ padding }) => (padding ? padding : '0.7rem 2rem')};
  justify-content: ${({ justifyContent }) => (justifyContent ? justifyContent : 'center')};
  border-radius: ${({ borderRadius }) => borderRadius};
  align-self: ${({ alignSelf }) => (alignSelf ? alignSelf : 'center')};
  background-color: ${({ colorbutton }) => colorbutton};
  margin: ${({ margin }) => (margin ? margin : '0')};
  cursor: pointer;
`;
